import { Box, Stack, Skeleton } from "@chakra-ui/react";

const Chunk = ({ width = "100%", height = "18px" }) => <Skeleton height={height} width={width} borderRadius="md" />;

const RightCard = ({ hasButtons }: { hasButtons?: boolean }) => (
    <Box bg="white" p={{ base: "1rem", md: "1.5rem" }} borderRadius="md" boxShadow="xs">
        <Stack gap={4}>
            <Chunk width="40%" height="20px" />
            <Chunk width="80%" height="16px" />
            <Chunk width="65%" height="16px" />

            {hasButtons && (
                <Stack direction="row" gap={4} pt={2}>
                    <Chunk height="42px" width="120px" />
                    <Chunk height="42px" width="160px" />
                </Stack>
            )}
        </Stack>
    </Box>
);

export const FeesAndExpensesSkeleton = () => (
    <Box flex={{ base: "unset", lg: "2" }} minW={0} w="100%">
        <Chunk width="260px" height="32px" />

        <Stack gap={4} mt={4}>
            <RightCard />
            <RightCard />
            <RightCard />
            <RightCard />
            <RightCard />
            <RightCard />
            <RightCard hasButtons />
        </Stack>
    </Box>
);
